import { Card, CardActions, CardContent, Typography } from "@mui/material";
import React from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GreyButton from "./GreyButton";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CommbankLogo } from "../assets/commonwealth-bank-2-logo-svg-vector.svg";
import { ReactComponent as SwyftxLogo } from "../assets/6385b3d7140115fbf69f92db_SwyftX Logo.svg";
import { ReactComponent as SelfWealthLogo } from "../assets/Selfwealth New 2022.svg";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function SupportedPlatformCard({ platform, linked }) {
    const navigate = useNavigate();

    const theme = createTheme({
        secondary: "#EEEEEE",
    });
    return (
        <ThemeProvider theme={theme}>
            <Card sx={{ my: 3, minWidth: "80%" }}>
                <CardContent
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background:
                            "linear-gradient(315deg, #ffffff 0%, #d7e1ec 74%)",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {platform.toLowerCase() === "commbank" ? (
                            <CommbankLogo
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    marginLeft: -5,
                                }}
                            />
                        ) : platform.toLowerCase() === "swyftx" ? (
                            <SwyftxLogo
                                style={{
                                    height: "20px",
                                    marginLeft: -5,
                                    width: "75px",
                                    marginRight: "5px",
                                }}
                            />
                        ) : platform.toLowerCase() === "selfwealth" ? (
                            <SelfWealthLogo
                                style={{ height: "50px", marginLeft: -5 }}
                            />
                        ) : (
                            <AccountBalanceIcon sx={{ px: 1.5 }} />
                        )}
                    </div>
                    <CardActions>
                        <GreyButton
                            onClick={
                                linked
                                    ? () => navigate("/profile/manage-links")
                                    : () => navigate(platform)
                            }
                        >
                            {linked ? "manage" : "Link"}
                        </GreyButton>
                    </CardActions>
                </CardContent>
                <CardContent>
                    {platform.toLowerCase() === "commbank" ? (
                        <Typography variant="body1" sx={{ fontWeight: 200 }}>
                            Link your Netbank account to get information on your
                            bank accounts
                        </Typography>
                    ) : platform.toLowerCase() === "swyftx" ? (
                        <Typography variant="body1" sx={{ fontWeight: 200 }}>
                            Link a swyftx account to get information on your
                            swyftx holdings
                        </Typography>
                    ) : platform.toLowerCase() === "selfwealth" ? (
                        <Typography variant="body1" sx={{ fontWeight: 200 }}>
                            Link a selfwealth account to get information on your
                            portfolio/s
                        </Typography>
                    ) : (
                        <></>
                    )}
                </CardContent>
            </Card>
        </ThemeProvider>
    );
}
